import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { isEqual } from 'lodash';

@Component({
  selector: 'form-input',
  templateUrl: './form-input.template.html',
  styleUrls: ['./form-input.style.scss'],
  host: {
    '(mouseenter)': 'onMouseEnter()',
    '(mouseleave)': 'onMouseLeave()'
  }
})
export class FormInputComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() public error: string;
  @Input() public label: string;
  @Input() public attribute: string;
  @Input() public placeholder: string;
  @Input() public type: string = 'text';
  @Input() public minVal: number;
  @Input() public maxVal: number;
  @Input() public options: Array<any>;
  @Input() public notHoveringValue: string;
  @Input() public forceFirstChange: boolean = false;
  @Input() public forceFocus: boolean = false;
  @Output() public attributeChange: EventEmitter<string> = new EventEmitter<string>(true);

  @ViewChild('input', { static: false}) input: ElementRef;

  public capitalLabel: string;

  hovering: boolean = false;

  hasError: boolean = false;

  constructor(private cdRef: ChangeDetectorRef) {
  }

  ngOnInit() {
    if (typeof(this.label) !== 'undefined') {
      // TODO: rebuild label on input change
      this.capitalLabel = this.label;
    }

    if (this.options && this.forceFirstChange) {
      this.attributeChange.emit(this.options[0].value !== undefined ? this.options[0].value : this.options[0]);
      this.cdRef.detectChanges();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.options && changes.options && this.forceFirstChange) {
      if (!isEqual(changes.options.previousValue, changes.options.currentValue)) {
        this.attributeChange.emit(this.options[0].value !== undefined ? this.options[0].value : this.options[0]);
        this.cdRef.detectChanges();
      }
    }

    if (changes.forceFocus) {
      if (this.input && this.forceFocus) this.input.nativeElement.focus();
    }
  }

  ngAfterViewInit() {
    if (this.input && this.forceFocus) this.input.nativeElement.focus();
  }

  onMouseEnter() {
    this.hovering = true;
  }

  onMouseLeave() {
    this.hovering = false;
  }

  private capitalizeLabel(string) {
    return string.replace(/(?:^|\s)\S/g, function (a) {
      return a.toUpperCase();
    });
  }

  private minMaxChanged(e) {
    if (this.minVal || this.maxVal) {
      if (this.minVal && e < this.minVal) this.attribute = String(this.minVal);
      if (this.maxVal && e > this.maxVal) this.attribute = String(this.maxVal);
      this.attributeChange.emit(this.attribute);
    }
  }
}
